import React from 'react'

import { Block, Typography } from '@xprog/prensa'

import { CaptionProps } from './Caption.types'

const Caption = (props: CaptionProps) => {
  const blockProps = {
    ...props?.customCssWrap,
    maxWidth: props?.isFullWidth ? '100%' : props?.customCssWrap?.maxWidth,
    width: props?.isFullWidth ? '100%' : props?.customCssWrap?.width
  }
  return (
    <Block css={blockProps}>
      <Typography
        as={props.as}
        css={props.customCss}
        variant={props.variant}>
        {props.value || props.children}
      </Typography>
    </Block>
  )
}

Caption.defaultProps = {
  as: 'p',
  customCssWrap: {
    maxWidth: '960px',
    width: '100%',
    mb: '$8',
    mt: '0'
  },
  customCss: {
    fontFamily: '$secondary',
    px: '$2',
    py: '$0',
    width: 'calc(100% - 32px)',
  },
  variant: 'default-heading-1xl'
}

export default Caption